import { connectionStore } from "../../stores";
import { RESTClient } from "../../network";
export function createRESTConn(params) {
    const conn = new RESTClient({
        handlers: {
            requestFormatter: params.handlers.requestFormatter,
            responseFormatter: params.handlers.responseFormatter
        }
    });
    connectionStore.set(params.name, conn);
    return conn;
}
//# sourceMappingURL=createRESTConn.js.map